<template>
    <div class="approve_initiate_wrap" v-loading="loading">
        <div class="approve_initiate_top_wrap">
            <div class="approve_initiate_top_left_wrap">
                <div class="approve_initiate_top_title">
                    <h5>常用审批</h5>
                    <span class="handle_icon_wrap" @click="handleClickEditCommon">
                        <i class="iconfont icon-a-tianjiamiaobian"></i>
                    </span>
                </div>
                <div class="bottom">
                    <ul>
                        <li v-for="item in common_applications_list" @click="handleClickAddApproval(item)">
                            <div class="icon">
                                <img :src="item.approval_set && item.approval_set.icon" alt="">
                            </div>
                            <p v-text="item.approval_set && item.approval_set.name"></p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="approve_initiate_top_right_wrap">
                <div class="approve_initiate_top_title">
                    <h5>审批中心</h5>
                </div>
                <div class="bottom">
                    <ul>
                        <li @click="handleClickApprovalCenter('awaiting_my_action')">
                            <div>
                                <span>{{ approvalPendingNum > 99 ? "99+" : approvalPendingNum}}</span>
                            </div>
                            <p>待处理</p>
                        </li>
                        <li @click="handleClickApprovalCenter('already_handled_by_me')">
                            <div><img src="https://download.hecoos.com/enlightv/2024-45/1e54b34cc476fb1e5e2198a565bc142c.png" alt=""></div>
                            <p>已处理</p>
                        </li>
                        <li @click="handleClickApprovalCenter('initiated_by_me')">
                            <div><img src="https://download.hecoos.com/enlightv/2024-45/9dad4fbfec146b1bb4da3fa835895872.png" alt=""></div>
                            <p>已发起</p>
                        </li>
                        <li @click="handleClickApprovalCenter('received_by_me')">
                            <div><img src="https://download.hecoos.com/enlightv/2024-45/29e359aba94a87273f901dd7fe32b836.png" alt=""></div>
                            <p>已收到</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="approve_initiate_bottom_wrap">
            <div class="approve_initiate_bottom_title">
                <h5>全部审批</h5>
                <div class="custome_input_262">
                    <el-input  v-model="searchForm.keyword" size="small"  placeholder="搜索您想要的内容"   suffix-icon="el-icon-search"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch"></el-input>
                </div>
            </div>
            <div class="approve_initiate_bottom_cont">
                <div class="approve_initiate_bottom_left">
                    <ul>
                        <li v-for="(item,key) in approvalList" :key="key" :class="activeCategoryId == item.id ? 'active' : ''" @click="handleClickCategory(item)">
                            <span class="name ellipsis" v-text="item.name"></span>
                            <span class="total" v-if="item.approvals" v-text="item.approvals.length > 99 ? '(99+)' : '('+ item.approvals.length +')'"></span>
                        </li>
                    </ul>
                </div>
                <div class="approve_initiate_bottom_right" ref="approve_initiate_bottom_right">
                    <el-collapse v-model="activeCategory" >
                        <el-collapse-item  v-for="(item,key) in approvalList" :name="item.id" :ref="'approve_collapse_' + item.id">
                            <template slot="title">
                                {{item.name}} <span v-if="item.approvals">({{item.approvals.length}})</span>
                            </template>
                            <div class="approve_initiate_bottom_list">
                                <ul v-if="item.approvals">
                                    <li v-for="list in item.approvals" @click="handleClickAddApproval(list)">
                                        <div class="icon">
                                            <img :src="list.icon" alt="">
                                        </div>
                                        <p v-text="list.name"></p>
                                    </li>
                                </ul>
                            </div>
                        </el-collapse-item>

                    </el-collapse>
                </div>
            </div>
        </div>

        <commonApproval :commonApprovalVisible.sync="commonApprovalVisible" @success="getCommonApprovalData" v-if="commonApprovalVisible" />
    </div>
</template>
<script>
import { commonList,approvalList ,ApprovalPendingNum} from "@/api/index.js"
import commonApproval from './component/commonApproval'
import {mapState} from "vuex";
export default {
    name: "initiateApproval",
    components: {
        commonApproval
    },
    data() {
        return {
            loading:false,
            common_applications_list:[],
            searchForm:{
                keyword:''
            },
            approvalList:[ ],
            activeCategory:null,
            commonApprovalVisible:false,
            approvalPendingNum: 0,
            activeCategoryId:0
        }
    },
    created() {

        this.getApprovalData()
        this.getApprovalPendingNum()
    },
    computed: {
        ...mapState(['tagList'])
    },
    mounted() {

    },
    methods: {
        handleClickSearch(){
            this.getApprovalData()
        },
        // 获取常用审批
        getCommonApprovalData(){
            this.loading = true
            commonList().then(res=> {
                if(res.code === 200) {
                   this.common_applications_list = res.data
                }
                this.loading = false
            })
        },
        // 编辑常用审批
        handleClickEditCommon(){
            this.commonApprovalVisible = true
        },
        // 跳转到新增审批
        handleClickAddApproval(item){
            this.$router.push({
                name: 'approveAdd',
                query:{
                    id:item.approval_set_id ? item.approval_set_id :item.id,
                    name:item.name ? item.name : item.approval_set.name,
                    type: item.type
                },
                params: {
                    isPush: true
                }
            })
        },

        // 获取所有审批
        getApprovalData(){
            this.loading = true
            approvalList({keyword: this.searchForm.keyword}).then(res=> {
                if(res.code === 200) {
                    this.approvalList = res.data
                    if(res.data && res.data.length>0){
                        this.activeCategory = res.data.map(map =>{ return map.id})
                    }
                }
                this.getCommonApprovalData()
            })
        },
        handleClickCategory(item){
            const targetElement = this.$refs['approve_collapse_' + item.id][0].$el
            if (targetElement) {
                this.$refs.approve_initiate_bottom_right.scrollTo({
                    top: targetElement.offsetTop - 375,
                    behavior: "smooth", // 平滑滚动
                });
            }
            this.activeCategoryId = item.id
        },
        // 查看审批中心
        handleClickApprovalCenter(state) {
            this.$emit("lookApprovalCenter", state)
        },
        // 获取待处理数量
        getApprovalPendingNum() {
            ApprovalPendingNum().then(res=> {
                if(res.code === 200) {
                    const data = res.data
                    this.approvalPendingNum = data.num || 0
                }
            })
        }
    }
}
</script>

<style  lang="scss" scoped>
@import "@/styles/approval.scss";

</style>